import React from 'react'
import { GrStorage } from "react-icons/gr";
import { CiCloudOn } from "react-icons/ci";
import { GoCodeSquare } from "react-icons/go";

const Hardwares = () => {
    return (
        <div className='hardwares'>
            <div className='item'>
                <div className='icon'><GrStorage size={40} /></div>
                <div className='title'><strong>Server, Storage, and Data Center Solutions</strong></div>
                <div className='item-menus'>
                    <div className='item-menu-item'><span>Hewlett Packard Enterprise (HPE)</span></div>
                    <div className='item-menu-item'><span>Dell EMC</span></div>
                    <div className='item-menu-item'><span>NetApp</span></div>
                    <div className='item-menu-item'><span>IBM</span></div>
                    <div className='item-menu-item'><span>Oracle</span></div>
                    <div className='item-menu-item'><span>Cohesity</span></div>
                    <div className='item-menu-item'><span>Nutanix</span></div>
                </div>
            </div>
            <div className='item'>
                <div className='icon'><GrStorage size={40} /></div>
                <div className='title'><strong>Network and Cybersecurity Solutions</strong></div>
                <div className='item-menus'>
                    <div className='item-menu-item'><span>Cisco</span></div>
                    <div className='item-menu-item'><span>Brocade</span></div>
                    <div className='item-menu-item'><span>Barracuda</span></div>
                    <div className='item-menu-item'><span>Forcepoint</span></div>
                    <div className='item-menu-item'><span>Mellanox</span></div>
                    <div className='item-menu-item'><span>Fortinet</span></div>
                    
                </div>
            </div>
            <div className='item'>
                <div className='icon'><CiCloudOn size={40} /></div>
                <div className='title'><strong>Cloud and Virtualization Solutions</strong></div>
                <div className='item-menus'>
                    <div className='item-menu-item'><span>AWS (Amazon Web Services)</span></div>
                    <div className='item-menu-item'><span>VMware</span></div>
                    <div className='item-menu-item'><span>Citrix</span></div>
                    <div className='item-menu-item'><span>Microsoft Azure</span></div>
                </div>
            </div>
            <div className='item'>
                <div className='icon'><GoCodeSquare size={40} /></div>
                <div className='title'><strong>Software, Automation, and Business Process Management</strong></div>
                <div className='item-menus'>
                    <div className='item-menu-item'><span>Adobe</span></div>
                    <div className='item-menu-item'><span>Automation Anywhere</span></div>
                    <div className='item-menu-item'><span>Tibco</span></div>
                    <div className='item-menu-item'><span>Cloudera</span></div>
                    <div className='item-menu-item'><span>Microfocus</span></div>
                    <div className='item-menu-item'><span>VirtualMetric</span></div>
                    <div className='item-menu-item'><span>Zimbra</span></div>
                </div>
            </div>
            <div className='item'>
                <div className='icon'><CiCloudOn size={40} /></div>
                <div className='title'><strong>Other Enterprise Solutions and Hardware</strong></div>
                <div className='item-menus'>
                    <div className='item-menu-item'><span>HP (Hewlett Packard)</span></div>
                    <div className='item-menu-item'><span>Ergotron</span></div>
                    
                </div>
            </div>
            
        </div>
    )
}

export default Hardwares
